var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    viewBox: "0 0 3000.0 3000.0",
    enableBackground: "new 0 0 3000.0 3000.0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M496.25,1081.58L269.43,1089.37L129.72,1090.76L128.13,741.81L262.12,737.57L496.25,740.36L488.76,461.19L489.39,247.12L514.75,119.92L716.95,127.75L733.83,359.98L804.86,123.02L932.89,129.97L970.55,347.21L971.64,737.62L1223.25,746.92L1598.80,725.46L1832.32,728.57L2052.25,728.57L2049.63,330.38L2072.24,131.64L2212.98,132.32L2260.56,355.54L2323.13,138.16L2522.93,133.83L2565.57,339.46L2558.14,722.69L2938.90,718.68L2925.69,1072.70L2574.38,1077.02L2574.38,1574.61L2389.92,1575.57L2326.32,1292.96L2270.67,1602.66L2060.01,1574.61L2072.09,1089.54L949.29,1081.43L949.29,1566.37L739.79,1568.15L694.73,1258.64L624.22,1577.37L488.96,1577.34L496.25,1081.58z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M1527.53,1646.49C1633.59,1275.57,1739.64,904.65,1818.68,740.36C1897.72,576.07,1949.75,618.41,1959.00,741.74C1968.26,865.06,1934.75,1069.37,1915.69,1229.58C1896.64,1389.80,1892.04,1505.93,1864.31,1566.37C1836.58,1626.81,1785.72,1631.57,1800.69,1801.91C1815.66,1972.25,1896.46,2308.17,1978.61,2508.63C2060.76,2709.09,2144.25,2774.09,1983.27,2812.85C1822.28,2851.60,1416.83,2864.12,1230.40,2848.68C1043.98,2833.25,1076.59,2789.85,1151.68,2542.75C1226.77,2295.64,1344.35,1844.82,1441.86,1631.56C1539.36,1418.31,1616.81,1442.62,1627.74,1484.70C1638.68,1526.78,1583.10,1586.64,1527.53,1646.49z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M1275.96,585.49C1302.88,598.14,1329.79,610.80,1351.27,660.50C1372.74,710.20,1388.77,796.94,1394.63,785.40C1400.49,773.86,1396.17,664.03,1431.95,615.52C1467.72,567.00,1543.59,579.79,1576.41,628.59C1609.23,677.38,1599.00,762.19,1609.98,762.42C1620.96,762.65,1653.14,678.31,1674.28,640.59C1695.43,602.88,1705.53,611.80,1732.55,624.54C1759.58,637.27,1803.52,653.83,1785.55,749.26C1767.58,844.70,1687.71,1019.01,1659.27,1122.34C1630.84,1225.66,1653.84,1258.00,1620.65,1224.56C1587.46,1191.12,1498.09,1091.89,1469.60,1093.15C1441.12,1094.40,1473.52,1196.13,1455.09,1234.93C1436.66,1273.73,1367.39,1249.61,1335.27,1198.23C1303.14,1146.86,1308.16,1068.24,1298.40,1088.43C1288.64,1108.62,1264.11,1227.61,1252.46,1228.41C1240.81,1229.21,1242.05,1111.81,1241.78,1141.98C1241.50,1172.14,1239.70,1349.87,1225.97,1367.51C1212.23,1385.15,1186.56,1242.71,1140.54,1122.19C1094.51,1001.68,1028.14,903.09,1002.16,817.27C976.18,731.44,990.60,658.38,1044.43,661.45C1098.27,664.51,1191.53,743.70,1223.25,746.92C1254.98,750.13,1225.18,677.36,1223.71,637.79C1222.24,598.22,1249.10,591.85,1275.96,585.49z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M1054.30,1047.48C1135.85,958.13,1217.40,868.78,1298.40,885.57C1379.40,902.37,1459.85,1025.32,1541.65,1035.68C1623.45,1046.04,1706.59,943.83,1729.50,1033.31C1752.40,1122.79,1715.06,1403.97,1664.63,1563.53C1614.20,1723.10,1550.66,1761.06,1483.05,1844.29C1415.45,1927.53,1343.76,2056.06,1317.13,2027.03C1290.50,1998.01,1308.92,1811.45,1276.80,1713.61C1244.69,1615.77,1162.04,1606.67,1119.12,1548.51C1076.20,1490.36,1073.01,1383.17,1070.21,1311.91C1067.41,1240.65,1065.00,1205.34,1062.41,1167.25C1059.83,1129.17,1057.06,1088.33,1054.30,1047.48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M2574.81,536.58L2771.41,536.58L2771.41,1266.32L2574.81,1266.32z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000000",
    fillOpacity: 1,
    strokeOpacity: 1,
    fillRule: "nonzero",
    strokeWidth: 33.531853,
    strokeLinejoin: "miter",
    strokeLinecap: "square",
    d: "M296.63,537.90L493.24,537.90L493.24,1267.64L296.63,1267.64z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo3);
export default __webpack_public_path__ + "static/media/Logo3.7c3fe85e0641a43d38dc358667d9a5d4.svg";
export { ForwardRef as ReactComponent };